// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cartItem{
  display: flex;
  margin-top: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid gainsboro;
  padding-bottom: 20px;
}

.cartItem:last-child{
  border-bottom: none;
}

.cartItem__info{
  padding-left: 20px;
}

.cartItem__info > button{
  border: unset;
  border-radius: 5px;
  background-color: transparent;
}

.cartItem__image{
  object-fit: contain;
  max-height: 100px;
  max-width: 100px;
}

.cartItem__title{
  font-size: 1em;
}

.cartItem__price{
  font-size: 1.2em;
}

.cartItem__incrDec{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
  width: 100px;
}

.cartItem__incrDec button{
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: gainsboro;
  border: none;
  border-radius: 100px;
}

.cartItem__incrDec button:hover{
  box-shadow: 0 2px 2px gray;
}

.cartItem__incrDec button:active{
  box-shadow: unset;
}

.cartItem__removeButton{
  color: rgb(241, 131, 131);
}

.cartItem__removeButton:hover{
  color: rgb(243, 92, 92);
}

.cartItem__removeButton:active{
  color: rgb(241, 131, 131);
}
`, "",{"version":3,"sources":["webpack://./src/components/cartItem.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".cartItem{\n  display: flex;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  border-bottom: 1px solid gainsboro;\n  padding-bottom: 20px;\n}\n\n.cartItem:last-child{\n  border-bottom: none;\n}\n\n.cartItem__info{\n  padding-left: 20px;\n}\n\n.cartItem__info > button{\n  border: unset;\n  border-radius: 5px;\n  background-color: transparent;\n}\n\n.cartItem__image{\n  object-fit: contain;\n  max-height: 100px;\n  max-width: 100px;\n}\n\n.cartItem__title{\n  font-size: 1em;\n}\n\n.cartItem__price{\n  font-size: 1.2em;\n}\n\n.cartItem__incrDec{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 10px 0;\n  width: 100px;\n}\n\n.cartItem__incrDec button{\n  width: 25px;\n  height: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: gainsboro;\n  border: none;\n  border-radius: 100px;\n}\n\n.cartItem__incrDec button:hover{\n  box-shadow: 0 2px 2px gray;\n}\n\n.cartItem__incrDec button:active{\n  box-shadow: unset;\n}\n\n.cartItem__removeButton{\n  color: rgb(241, 131, 131);\n}\n\n.cartItem__removeButton:hover{\n  color: rgb(243, 92, 92);\n}\n\n.cartItem__removeButton:active{\n  color: rgb(241, 131, 131);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
